import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/core/sexos${queryUrl}`)
  },
  insertNewGender(data) {
    return axios.post('/core/sexos', data)
  },
  editGender(data) {
    return axios.put(`/core/sexos/${data.id}`, data)
  },
  deleteGender(id) {
    return axios.delete(`/core/sexos/${id}`)
  },
}
